/**
 * Created by harris on 17-2-18.
 */
import AppConfig from 'src/config'
const doc = document;

// 头部加载JS
export const loadJS = function (url) {

  return new Promise(function (resolve, reject) {
    let script = doc.createElement('script');
    script.type = 'text/javascript';
    script.onload = function () {
      this.onload = this.onerror = null;
      resolve(this);
      this.parentNode.removeChild(this);
    }

    script.onerror = function () {
      reject(this);
    }

    script.src = url;
    doc.getElementsByTagName('head')[0].appendChild(script);
  })
}

// 内容替换【编码不在0~255之间的字符，全部以**替代】
export const bLength = function (str) {
    return (str + "").replace(/[^\x00-\xff]/g,'**').length
}

// 补全图片链接
export const compleImage = function (value) {
    if(value){
        if(value.indexOf("http") < 0){  // 图片的路径是相对路径，则不全基本的URL
            return AppConfig.imgBaseUrl+value;
        }else{  // 绝对路径，则直接返回
            return value;
        }
    }else{
        return value;
    }
}

//补全分享链接
export const shareConfig = function (config) {
    if(config == null || config == undefined){
        config = {};
    }
    // 获取当前页面的baseUrl
    let baseUrl     = 'http://'+window.location.host;
    let shareConfig = {};
    shareConfig = {
        'title':config.title?config.title:AppConfig.wx.shareConfig.title,
        'desc':config.desc?config.desc:AppConfig.wx.shareConfig.desc,
        'link':config.link?config.link:baseUrl+AppConfig.wx.shareConfig.link,
        'imgUrl':config.imgUrl?config.imgUrl:AppConfig.wx.shareConfig.imgUrl,
    }
    return shareConfig;
}

// 切割字符串，超出省略
export const textCut = function (str, num, dot) {
    num = parseInt(num, 10);
    if (isNaN(num)) {
      num = 75;
    }

    let len = bLength(str),
      newLen = 0,
      newStr = "";

    if (len <= num * 2) {
      return str;
    }
    for (let i = 0; i < len; i++) {
      let tmp = str.charCodeAt(i);
      if (tmp > 255) {
        newLen++;
      }
      newLen++;
      if (newLen >= num * 2) {
        break;
      }
      newStr += str[i];
    }

    return newStr + (dot ? "..." : "");
}

// 判断手机型号
export const os = function () {
    "use strict";
    let ua = window.navigator.userAgent,
      matched;
    let os = {
      name: "unknown",
      version: "0.0.0"
    };

    if ((matched = ua.match(/Windows\sPhone\s(?:OS\s)?([\d\.]+)/))) {
      os = {
        name: 'Windows Phone',
        isWindowsPhone: true,
        version: matched[1]
      }
    } else if (!!ua.match(/Safari/) && (matched = ua.match(/Android[\s\/]([\d\.]+)/))) {
      os = {
        version: matched[1]
      };

      if (!!ua.match(/Mobile\s+Safari/)) {
        os.name = 'Android';
      } else {
        os.name = 'AndroidPad';
        os.isAndroidPad = true;
      }
      os.isAndroid = true;
    } else if ((matched = ua.match(/(iPhone|iPad|iPod)/))) {
      let name = matched[1];

      matched = ua.match(/OS ([\d_\.]+) like Mac OS X/);

      os = {
        name: name,
        isIphone: (name === 'iPhone' || name === 'iPod'),
        isIpad: name === 'iPad',
        isIOS: true,
        version: matched[1].split('_').join('.')
      }
    }

    return os;
  }();

// 获取COOKIE信息
export const getCookie = function (name) {
  let arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
  if(arr != null) {
    return unescape(arr[2]);
  }
  return null;
}

// 根据平台的不同，进行样式的划分
export const getPlatStyle = function (type) {
    let isIOS  = os.isIOS;
    let height = 0;
    if(type == 'bth-ask'){
        height = isIOS?0:30;
    }else if(type == 'quest-bottom'){
        height = isIOS?100:100;
    }else if(type == 'lastspace'){
        height = isIOS?68:38;
    }
    let params = {height:height};
    return params;
}

//数据超出统一样式
export const getShowNum = function (num) {
    let number = 0;
    if(num > 99999){
        number = '99999+';
    }else{
        number = num;
    }
    return number;
}





// WEBPACK FOOTER //
// ./src/lib/Util.js